module.exports = __webpack_public_path__ + "static/media/icon_nav_user_active.d0911081.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_nav_user_active.svg
// module id = 336
// module chunks = 0